import IconRightArrow from "./icon-right-arrow";

export default IconRightArrow;
